export const ajustesGlobalesIaFormModel = {
  formId: 'ajustesGlobalesIaForm',
  formField: {
    defaultChatServiceId: {
      name: 'defaultChatServiceId',
      label: 'Servicio por Defecto (Chat)',
      errorMsg: 'Seleccione un servicio válido',
    },
    defaultImageServiceId: {
      name: 'defaultImageServiceId',
      label: 'Servicio por Defecto (Imagen)',
      errorMsg: 'Seleccione un servicio válido',
    },
    defaultAudioServiceId: {
      name: 'defaultAudioServiceId',
      label: 'Servicio por Defecto (Audio)',
      errorMsg: 'Seleccione un servicio válido',
    },
    defaultEmbeddingServiceId: {
      name: 'defaultEmbeddingServiceId',
      label: 'Servicio por Defecto (Embedding)',
      errorMsg: 'Seleccione un servicio válido',
    },
    defaultOcrServiceId: {
      name: 'defaultOcrServiceId',
      label: 'Servicio por Defecto (OCR)',
      errorMsg: 'Seleccione un servicio válido',
    },
    creditsPerUsd: {
      name: 'creditsPerUsd',
      label: 'Créditos por USD',
      errorMsg: 'Ingrese un valor válido',
    },
    defaultTemperature: {
      name: 'defaultTemperature',
      label: 'Temperatura (0 a 2)',
      errorMsg: 'Ingrese un valor entre 0 y 2',
    },
    defaultTopP: {
      name: 'defaultTopP',
      label: 'Top P (0 a 1)',
      errorMsg: 'Ingrese un valor entre 0 y 1',
    },
    defaultMaxTokens: {
      name: 'defaultMaxTokens',
      label: 'Máximo de Tokens',
      errorMsg: 'Ingrese un valor válido',
    },
    enableStreaming: {
      name: 'enableStreaming',
      label: 'Habilitar Streaming',
    },
    enableMemory: {
      name: 'enableMemory',
      label: 'Habilitar Memoria',
    },
    enableCache: {
      name: 'enableCache',
      label: 'Habilitar Caché',
    },
    enableTools: {
      name: 'enableTools',
      label: 'Habilitar Tools',
    },
    enableLogs: {
      name: 'enableLogs',
      label: 'Habilitar Logs',
    },
    allowBringYourOwnKey: {
      name: 'allowBringYourOwnKey',
      label: 'Permitir BYOK (Bring Your Own Key)',
    },
  },
};
